<div class="form__group" [ngClass]="cssClass">
  <div class="form__label number-block" [class.form__label_require]="require && !disabled" [class.form__label_error]="error">
    @if (current_value) {
      <span title="{{current_value | priceName: multiplyThousand}}">{{firstString}} <b class="font-weight-bold">{{current_value | priceName: multiplyThousand}}</b></span>
    }
    @if (!current_value) {
      {{firstString}} <ng-content></ng-content>
    }
  </div>
  <div class="form__input" [class.form__input_disabled]="disabled" [class.form__input_focus]="focus"
    [class.form__input_error]="error">
    <input [type]="type" class="input" [value]="current_value" [disabled]="disabled"
      (keyup)="onChangeDigit($event, $event.target)"
      (focus)="focus = true"
      (blur)="focus = false"
      [ngClass]="{'md-valid': current_value && (current_value.length || current_value > 0)}"
      [placeholder]="placeholder">
  </div>
  <!--<div class="form__input__shortcut" *ngIf="potential_shortcut">
  ={{potential_shortcut}}
</div>-->
</div>
